export default "__VITE_ASSET__Cxp0814o__"